const themeLink = document.currentScript.src.split("PDPKitGrouping")[0];
let groups = document.currentScript.getAttribute('group');
const coreColors = document.currentScript.getAttribute('core');
groups = groups.split(",");
console.log(groups)
let uniqueGroups = [...new Set(groups)];
let kitQuery = `{`
for (const [i, tag] of uniqueGroups.entries()) {
  kitQuery += `group${i}: products(query: "tag:'${tag}'", first: 20, sortKey: TITLE) {
    edges{
      node{
        ...productDetails
      }
    }
  }`;
}
kitQuery += `}
fragment productDetails on Product {
  title
  handle
  id
  exclude: metafield(namespace: "c_f", key: "exclude_colors_for_online") {
    value
  }
  badge: metafield(namespace: "custom_fields", key: "merchandising_message_tag") {
    value
  }
  media(first: 1) {
    edges {
      node {
        alt
        mediaContentType
        previewImage {
          url
        }
      }
    }
  }
  variants(first: 20) {
    edges {
      node {
        availableForSale
        quantityAvailable
        price {
          amount
        }
        compareAtPrice {
          amount
        }
        title
        id
        sku
      }
    }
  }
}`

fetch(window.api_url, {
    method: 'POST',
    'crossDomain': true,

    headers: {
      'X-Shopify-Storefront-Access-Token': window.api_key,
      "Content-Type": "application/json"
    },

    body: JSON.stringify({
      query: kitQuery
    })
  })
  .then((response) => response.json())
  .then(function(data) {
    window.varData = data.data;
    Object.entries(window.varData).forEach(([key, value], index) => {
      initBuildSwatch(value.edges, index);
    })
  }).then(function() {
    document.querySelectorAll(`.product-kit-item[data-group-index]`).forEach((el) => {
      if (el.querySelector(".size-btn.active") == undefined) {
        el.querySelectorAll(".size-btn")[0].classList.add("active");
      }
      el.addEventListener("click", function(e) {
        if (e.target.classList.contains("swatch-btn-kit")) {
          let container = e.target.closest(".swatch-list");
          let swatch = e.target;
          container.querySelectorAll(".swatch-btn-kit").forEach((e) => {
            e.classList.remove("active");
          });
          swatch.classList.add("active");
          buildSizes(window.varData, el.dataset.groupIndex, swatch.dataset.index);
        }
        if (e.target.classList.contains("size-btn")) {
          if (e.target.classList.contains("sold-out")) {
            document.getElementById("add-to-cart-kit").disabled = true;
          } else {
            document.getElementById("add-to-cart-kit").disabled = false;
          }
        }
      });
    });
  }).then(() => {
    document.querySelectorAll('.swatch-btn-kit').forEach((swatch) => {
      let previousTitle = '';
      swatch.addEventListener("click", (e) => {
        previousTitle = swatch.getAttribute("data-swatch-color");
        const productId = swatch.getAttribute('data-product-id');
        const waitlistProductId = $('.product-waitlist [name="waitlist-product-id"]');
        waitlistProductId.val(productId);
      })
      swatch.addEventListener("mouseenter", (e) => {
        previousTitle = e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML;
        e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML = swatch.getAttribute("data-swatch-color");
      });
      swatch.addEventListener("mouseleave", (e) => {
        e.target.closest(".product-variants").querySelector(".product-variants-label").innerHTML = previousTitle;
      });
    });
  });

function initBuildSwatch(data, index) {
  let container = document.querySelector(`.product-kit-item[data-group-index='${index}']`);
  if (!container) return;
  let markup = '';
  for (var i = 0; i < data.length; i++) {
    let product = data[i].node;
    var title = product.media.edges[0].node.alt;
    title = title.substring(title.indexOf('#') + 1).trim();
    if (product.exclude != null) {
      if (product.exclude.value.includes(title)) {
        continue;
      }
    }
    markup += `<button type="button" style="background-image: url(${themeLink}color-${title.toLowerCase().replaceAll(" ", "-")}_35x.png)" aria-label="${title} color selector" class="swatch-btn-kit`;

    const activeKitSwatch = container.querySelector(".swatch-btn-kit.active");
    if (activeKitSwatch && activeKitSwatch.dataset.swatchColor == title) {
      markup += ` active`;
    }
    markup += `"  data-swatch-image="${product.media.edges[0].node.previewImage.url.replace(/(\.[\w\d_(?=\?)-]+)$/i, '_360x$1')}"
    data-index='${i}'
    data-swatch-id="${product.variants.edges[0].node.id.replace("gid://shopify/ProductVariant/", "")}"
    data-swatch-color="${title}" 
    data-product-id='${product.id.replace("gid://shopify/Product/", "")}'
    data-swatch-handle="${product.handle}" 
    data-price="${product.variants.edges[0].node.price.amount}" 
    aria-label="${title}"></button>`;
  }
  container.querySelector(".swatch-list").innerHTML = markup;
}

function buildSizes(data, gIndex, pIndex) {
  let container = document.querySelector(`.product-kit-item[data-group-index='${gIndex}']`);
  let product = Object.values(window.varData)[gIndex].edges[pIndex].node;
  let variants = product.variants.edges;
  container.querySelectorAll("ul li").forEach((e, i) => {

    let variant = e.querySelector(".size-btn");
    let variantInfo = e.querySelector(".variant-info");
    let varId = variants[i].node.id.replace("gid://shopify/ProductVariant/", "");
    if (!variants[i].node.availableForSale) {
      variant.classList.add("sold-out");
      variantInfo.querySelector(".cr-red").innerHTML = "SOLD OUT";
      variantInfo.querySelector(".cr-red").classList.remove("hide");
    } else {
      if (container.querySelector(".size-btn.active") == undefined) {
        variant.classList.add("active");
      }
      if (variants[i].node.quantityAvailable < 10) {
        variantInfo.querySelector(".cr-red").innerHTML = `ONLY ${variants[i].node.quantityAvailable} LEFT`;
        variantInfo.querySelector(".cr-red").classList.remove("hide");
      } else {
        variantInfo.querySelector(".cr-red").innerHTML = '';
      }
      variant.classList.remove("sold-out");
    }
    variant.setAttribute("data-variant-id", varId);
    variant.setAttribute("data-variant-sku", variants[i].node.sku);
    variant.setAttribute("data-variant-price", variants[i].node.price.amount);
    variant.setAttribute("data-variant-dy-price", variants[i].node.price.amount);
    variant.setAttribute("data-kit-handle", product.handle);
  });
}

const guideOpen = $('.size-guide-open');
const guideClose = $('.size-guide-close, .size-guide-overlay');
const fitSelector = $('#size-guide-fit-selector');
const sizeGuide = $('.product-size-guide');
const tabSelector = $('[data-size-chart-tabs-trigger]');

guideOpen.click(function () {
  html.addClass('size_guide_active');
  sizeGuide.addClass('active');
  let index = this.dataset.index;
  if(index != undefined){
    document.querySelectorAll(".size-content .kit_container").forEach((e)=>{
      e.classList.remove("active");
    });
    document.querySelector(`.kit_container[data-index='${index}']`).classList.add("active");
  }
});

guideClose.click(function () {
  html.removeClass('size_guide_active');
  sizeGuide.removeClass('active');
});

fitSelector.change(function () {
  $('[data-fit].active').removeClass('active');
  $(`[data-fit="${fitSelector.val()}"]`).addClass('active');
});

tabSelector.click(function () {
  let _this = $(this);

  _this.closest('li').addClass('active')
    .siblings().removeClass('active');

  $(`[data-size-chart-tabs="${_this.attr('data-size-chart-tabs-trigger')}"]`).addClass('active')
    .siblings().removeClass('active');
});